import 'reflect-metadata';
import React from 'react'
import ReactDOM from 'react-dom/client'
import { container } from 'tsyringe'
import { ApiService } from './api/ApiService'
import { ModelService } from './services/ModelService'
import { App } from './App'
import './i18n'
import { ModeProvider } from './shared/ModeContext'
import { ErrorBoundary } from './components/ErrorBoundary'

container.register(ApiService, { useClass: ApiService })
container.registerSingleton(ModelService, ModelService)

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <ErrorBoundary>
            <ModeProvider>
                <App />
            </ModeProvider>
        </ErrorBoundary>
    </React.StrictMode>
)
